import { TypePosition } from '../../interfaces/TypePosition'
import {
  GET_TYPE_POSITION_EXITO,
  GET_TYPE_POSITION
} from '../types/typePositionActionsTypes'

export type TypePositionAction = TypePositionsActions | TypePositionsActionAsync

// Esto va a REDUX
export interface TypePositionsActions {
  type: typeof GET_TYPE_POSITION_EXITO
  typePositions: TypePosition[] | undefined
  error: string | undefined
}

export const getTypePositionsAction = (
  typePositions?: TypePosition[],
  error?: string
): TypePositionsActions => {
  return {
    type: GET_TYPE_POSITION_EXITO,
    typePositions,
    error
  }
}

// Esto va a SAGA
export interface TypePositionsActionAsync {
  type: typeof GET_TYPE_POSITION
}

export const getTypePositionsActionAsync = (): TypePositionsActionAsync => {
  return {
    type: GET_TYPE_POSITION
  }
}
